import React from 'react';
export function Footer() {
  return <footer className="bg-brand-cream px-4 py-4 text-center" data-id="element-66" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl space-y-1" data-id="element-67" data-mp="3gfiuujlrgden">
        <p className="text-[11px] font-semibold text-brand-ink sm:text-xs" data-id="element-68" data-mp="3ghc486nrdbqc">
          © 2026 SMART HOME PRO™ — Tutti i Diritti Riservati.
        </p>
        <p className="text-[11px] font-medium leading-snug text-brand-muted sm:text-xs" data-id="element-69" data-mp="36oo5359b2vog">
          Questo sistema è fornito per finalità educative e formative. È progettato per aiutare a
          comprendere la domotica, pianificare sistemi Smart Home, configurare dispositivi
          compatibili, creare automazioni e organizzare progetti. L’utente rimane responsabile
          dell’utilizzo delle informazioni, della verifica delle specifiche dei produttori e del
          rispetto delle normative e dei requisiti di sicurezza applicabili. Gli interventi elettrici
          o regolamentati devono essere affidati a professionisti qualificati quando richiesto.
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-70" data-mp="3l9ahbtogro9p">
          Termini e Condizioni • Privacy Policy • Contatti
        </p>
        <p className="text-[11px] font-medium text-brand-muted sm:text-xs" data-id="element-71" data-mp="3gc0gzizjds73">
          Supporto:{' '}
          <a href="mailto:kitonline27@gmail.com" className="font-semibold text-brand-orange hover:underline" data-id="element-72" data-mp="3v919hopjxr6m">
            kitonline27@gmail.com
          </a>
        </p>
      </div>
    </footer>;
}